import { DateTime } from 'luxon'
import { digObject } from '@domain-group/javascript-utils'
import {
  Box, Checkbox, ListItem, Text,
} from '@domain-group/suit-theme'

import useArtwork from '@hooks/useArtwork'
import { useRelations as useOrderItemRelations } from '@hooks/useOrderItem'

import type { ArtworkModel } from '@models/artwork'

interface ArtworkProps {
  artwork: ArtworkModel,
  callbacks: {
    selectArtwork: VoidFunction,
  },
  selected: boolean,
}

const Artwork = (props: ArtworkProps) => {
  const {
    artwork,
    callbacks: {
      selectArtwork,
    },
    selected,
  } = props

  const artworkPayload = useArtwork(artwork)
  const {
    orderItem,
    orderItem: {
      // @ts-expect-error TS2339
      title,
      // @ts-expect-error TS2339
      options_string,
    },
  } = artworkPayload

  const createdAtString = digObject(artwork, 'dates.created.date_time')
  const updatedAtString = digObject(artwork, 'dates.updated.date_time')

  const dateTimeObj = DateTime.fromFormat(updatedAtString || createdAtString, 'dd/MM/yyyy HH:mm')

  const orderItemRelations = useOrderItemRelations(orderItem)
  const {
    publication,
    publicationEdition: {
      // @ts-expect-error TS2339
      publication_date,
    },
  } = orderItemRelations

  return (
    <ListItem
      boxProps={{ borderBottom: '1px dashed', paddingY: 'large' }}
      onClick={selectArtwork}
    >
      <Box alignItems="center" width="auto">
        <Checkbox checked={selected} />
      </Box>

      <Box flexDirection="column">
        <Text fontSize="small">
          {/*
           // @ts-expect-error TS2339 */}
          {!!publication.title && `${publication.title} - `}{title}
        </Text>

        <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="small">
          {publication_date || options_string || 'No Options'}
        </Text>

        <Text color="lightGrey" fontSize="xsmall" marginTop="small">
          Updated {dateTimeObj.toFormat("dd/MM/yyyy 'at' h:mma")}
        </Text>
      </Box>
    </ListItem>
  )
}

export default Artwork
